import NumberFormat from "react-number-format";

const LoanTermTab = ({ loanDetails, loanTerms }) => {
  const getPositionLabel = () => {
    switch (loanTerms?.["Loan Position"]) {
      case "First":
        return "1st";
      case "Second":
        return "2nd";
      case "Third":
        return "3rd";
      default:
        return loanTerms?.["Loan Position"];
    }
  };
  return (
    <section>
      {loanDetails && (
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td className="fw-bold">Loan Position:</td>
              <td>{getPositionLabel()}</td>
              <td className="fw-bold">Late Grace Period:</td>
              <td>{loanDetails["Grace Period"]} Days</td>
            </tr>
            <tr>
              <td className="fw-bold">Interest Rate:</td>
              <td>{loanDetails["Note Rate"]}</td>
              <td className="fw-bold">
                Late Charge Penalty (Percent of the P & I):
              </td>
              <td>{loanDetails["LateChgPct"]}</td>
            </tr>
            <tr>
              <td className="fw-bold">Interest Method:</td>
              <td>{loanTerms?.["Interest Method"]}</td>

              <td className="fw-bold">
                Late Charge Penalty ( Distribute to Lenders):
              </td>
              {/* <td>{loanDetails["DefaultRateLenderPct"]}</td> */}
              <td>{loanDetails["LateChgLenderPct"]}</td>
              {/* <td className="fw-bold">Minimum:</td> */}
            </tr>
            <tr>
              <td className="fw-bold">Payment Type:</td>
              <td>{loanTerms?.["Payment Type"]}</td>

              <td className="fw-bold">Rate Type:</td>
              <td>{loanTerms?.["Rate Type"]}</td>
            </tr>
            <tr>
              <td className="fw-bold">Minimum Late Charge:</td>
              <td>
                {
                  <NumberFormat
                    displayType="text"
                    value={loanTerms?.["Minimum"]}
                    prefix={"$"}
                    customInput={false}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    thousandSeparator={true}
                  />
                }
              </td>
              <td className="fw-bold">Default Rate</td>
              <td>{loanDetails["DefaultRateValue"]}</td>
            </tr>
            <tr>
              <td className="fw-bold">Maturity Date:</td>
              <td>{loanDetails["Maturity"]}</td>
              <td className="fw-bold"></td>
              <td></td>
            </tr>
            <tr>
              <td className="fw-bold">1st Payment Due Date:</td>
              <td>{loanDetails["First Payment"]}</td>
              <td className="fw-bold"></td>
              <td></td>
            </tr>
            <tr>
              <td className="fw-bold">Closing Date:</td>
              <td>{loanDetails["ClosingDate"]}</td>
              <td className="fw-bold"></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      )}
    </section>
  );
};
export default LoanTermTab;
